import { Clapperboard, Scissors, Users, Camera, Newspaper, Megaphone, Handshake, Music } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { INDUSTRY } from "@/lib/site";

const ICONS = { Clapperboard, Scissors, Users, Camera, Newspaper, Megaphone, Handshake, Music };

export default function Industry() {
  return (
    <section id="industry" className="py-28 lg:py-36 bg-royal-900/40 border-y border-gold/10 spotlight-fuchsia" data-testid="industry-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeading
          eyebrow="Celebrity & Industry Association"
          title={<>WHERE TALENT MEETS <span className="gold-text">THE INDUSTRY</span></>}
          sub="A bridge between emerging talent and the people who shape entertainment, fashion and media."
          testId="industry-heading"
        />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="industry-grid">
          {INDUSTRY.map((it, i) => {
            const Icon = ICONS[it.icon];
            return (
              <Reveal key={it.label} delay={0.05 * i}>
                <div
                  className="group glass-card rounded-md p-8 text-center transition-all duration-500 hover:border-gold/50 hover:-translate-y-1 hover:shadow-[0_0_30px_rgba(212,175,55,0.12)]"
                  data-testid={`industry-tile-${i}`}
                >
                  <Icon size={30} className="mx-auto text-gold transition-transform duration-500 group-hover:scale-110" />
                  <p className="mt-4 font-display text-lg text-cream/90">{it.label}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal className="mt-10 text-center">
          <p className="text-xs text-muted/70 max-w-xl mx-auto" data-testid="industry-disclaimer">
            Imagery shown is representational. HA Treasure House does not claim association with any celebrity unless explicitly announced.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
